import { render } from "./editEvent.vue?vue&type=template&id=7f0dc995&scoped=true"
import script from "./editEvent.vue?vue&type=script&lang=js"
export * from "./editEvent.vue?vue&type=script&lang=js"

import "./editEvent.vue?vue&type=style&index=0&id=7f0dc995&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0dc995"]])

export default __exports__